// extracted by mini-css-extract-plugin
module.exports = {"listItem":"ListingsListItem_listItem__3cX1W","name":"ListingsListItem_name__bdsHP","details":"ListingsListItem_details__2Ki1r","moreButton":"ListingsListItem_moreButton__1Xfmz"};